export default `
  subscription OnDeleteCardComment($workflowId: String) {
    onDeleteCardComment(workflowId: $workflowId) {
      workflowId
      cardId
      id
    }
  }
`
